import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';

import useSidePanelTearouts from './utils/useSidePanelTearouts';

import ItemCountAdjustButton from '~atoms/ItemCountAdjustButton';
import DesignStepContainer from '~molecules/DesignStepContainer';
import DesignSectionCard from '~organisms/DesignSectionCard';
import DesignSectionHeader from '~organisms/DesignSectionHeader';

const SidePanelTearoutsTab = () => {
  const { t } = useTranslation();
  const {
    tearOuts,
    isFetchingOptionalItems,
    setAreaQtyOrDeselect,
    increaseSelectedTearOut,
    decreaseSelectedTearOut,
    setSelectedTearOutQty,
  } = useSidePanelTearouts();

  return (
    <>
      <DesignSectionHeader
        title={t('SCROLLABLE_AREA.TEAR_OUT_COUNTERTOP.TITLE')}
        description={t('SCROLLABLE_AREA.TEAR_OUT_COUNTERTOP.DESCRIPTION')}
      />

      {isFetchingOptionalItems ? (
        <Spin style={{ fontSize: 24, marginLeft: '40%' }} />
      ) : (
        <DesignStepContainer>
          {tearOuts.map(([{ productId }, data]) => (
            <DesignSectionCard
              style={{ width: '100%' }}
              key={`tearout-${productId}`}
              title={data.title}
              image={data.image}
              isSelected={data.isSelected}
              onClick={setAreaQtyOrDeselect(productId)}
            >
              <p>{data.tearOutPrice}</p>
              <ItemCountAdjustButton
                quantity={data.isSelected ? data.quantity : undefined}
                onIncrease={increaseSelectedTearOut(productId)}
                onDecrease={decreaseSelectedTearOut(productId)}
                onUpdateValue={setSelectedTearOutQty(productId)}
              />
            </DesignSectionCard>
          ))}
        </DesignStepContainer>
      )}
    </>
  );
};

export default SidePanelTearoutsTab;
